import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

// Default fallback content — mirrors backend content_defaults.py so the site works
// even if the API is briefly unavailable during the first render.
const FALLBACK = {
    global: {
        logo_url: "/brand/umami-logo.png",
        halaal_logo_url: "/brand/halaal.webp",
        halaal_caption: "HALAAL CERTIFIED",
        halaal_subcaption: "Every dish, every day.",
        show_halaal_header: true,
        show_halaal_hero: true,
        phone_display: "068 676 0224",
        phone_tel: "+27686760224",
        whatsapp_number: "27686760224",
        address_line1: "33 Heronmere Road",
        address_line2: "Reuven, Johannesburg",
        hours_lines: ["Mon–Fri 08:00 – 16:30", "Sat 08:00 – 12:30", "Sun — Closed"],
    },
    home: {},
    menu_page: {
        script: "The Menu",
        title: "Menu",
        subtitle: "Ready-to-eat & retail. Pickup at 33 Heronmere Road, Reuven — usually ready in ~30 minutes.",
    },
    specials_page: {},
    about_page: {},
    contact_page: {},
    footer: {},
};

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
    const [content, setContent] = useState(FALLBACK);
    const [loaded, setLoaded] = useState(false);

    const refresh = async () => {
        try {
            const { data } = await client.get("/content");
            // Merge FALLBACK with API response so missing keys have defaults
            const merged = {};
            for (const key of Object.keys({ ...FALLBACK, ...data })) {
                merged[key] = { ...(FALLBACK[key] || {}), ...(data[key] || {}) };
            }
            setContent(merged);
            setLoaded(true);
        } catch (e) {
            console.warn("Content load failed", e);
            setLoaded(true);
        }
    };

    useEffect(() => { refresh(); }, []);

    return (
        <ContentContext.Provider value={{ content, refresh, loaded }}>
            {children}
        </ContentContext.Provider>
    );
}

export const useContent = () => {
    const ctx = useContext(ContentContext);
    return ctx?.content || FALLBACK;
};

export const useContentSection = (section) => {
    const c = useContent();
    return c[section] || FALLBACK[section] || {};
};

export const useContentRefresh = () => {
    const ctx = useContext(ContentContext);
    return ctx?.refresh || (() => {});
};
